import { render, staticRenderFns } from "./BoxFotos.vue?vue&type=template&id=2935b0f6"
import script from "./BoxFotos.vue?vue&type=script&lang=js"
export * from "./BoxFotos.vue?vue&type=script&lang=js"
import style0 from "./BoxFotos.vue?vue&type=style&index=0&id=2935b0f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports